import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Grid, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
//import VisibilityIcon from "@material-ui/icons/Visibility";
//import DeleteIcon from "@material-ui/icons/Delete";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
    wordBreak: 'break-all'
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
    marginRight: 10
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  charges: {
      letterSpacing: '0.5px'
  }
}));

export default function DetailedAccordion({
  headers,
  data,
  onView,
  onEdit,
  onDelete,
}) {
 
  const classes = useStyles();
  const id = IdKey.generate();
  const getValueByKey = (object, header) => {
    if ( header.field === "chargesUnderSupervision"  && header.child === 'denomination') {
      return object[header.field].map((item) => (<div className={classes.charges}>{item['denomination']}</div>) );
    }
    if(header.field === 'attribute' ){
      let array=[];
      try{
        array = JSON.parse(object[header.field])
      }catch(err){

      }
       
      return array?.blocks?.map((item) => (<div style={{wordBreak: 'break-all'}}>{item['text']}</div>))
    }
    if (header.child === null) {
        return object[header.field] !== null ? object[header.field] : "";
      }
      return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };


  return (
    <div className={classes.root}>
        <Accordion style={{borderLeftStyle: "solid", borderLeftColor: '#F8DF13'}}>
        <AccordionSummary aria-controls="panel1c-content" id={id}>
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading} style={{maxWidth: '60%',flexBasis: 'auto', wordBreak: 'break-all'}}>
                {getValueByKey(data, header)}
              </Typography> 
                           
            </div>
          ))}
          <div className={classes.columnEvent}>
            {/* <Tooltip title="Ver detalle" arrow placement="top">
              <VisibilityIcon className={classes.iconEvent} />
            </Tooltip>
            &nbsp;&nbsp; */}
              <Tooltip title="Editar" arrow placement="top">
                <EditIcon
                  onClick={() => onEdit(data.id)}
                  className={classes.iconEvent}
                />
              </Tooltip>
            &nbsp;&nbsp;
              {/* <Tooltip title="Anular" arrow placement="top">
                <DeleteIcon
                  onClick={() => onDelete(data.id)}
                  className={classes.iconEvent}
                />
              </Tooltip> */}
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.rootGrid}>
            <Grid container spacing={3}>
            {headers.otherHeaders.map((header) => (
                <Grid item xs={2}>
                  <Typography className={classes.heading}>
                    {header.title}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {getValueByKey(data, header)}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
